import 'swiper/css/bundle';
import Swiper from 'swiper';
import './single-product.scss';
import { Pagination } from 'swiper';

const singleProduct = () => {

    let args = {
        slidesPerView: 4,
        spaceBetween: 0,
        breakpoints: {
            0: {
                slidesPerView: 1.1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    };
    Swiper.use([Pagination]);

    let relatedSwiper = new Swiper(document.querySelector('.relatedProductsSwiper'), args);

}

export default singleProduct;